var m = require('mithril');
var moment = require('moment-timezone');
var cronstrue = require('cronstrue');
var choices = require('../libs/choices');
var Model = require('../libs/Model');
var loaders = require('../layout/components/loaders');
var modal = require('../layout/components/modal');
var ToggleSwitch = require('../components/toggleSwitch');
var scheduledReportModel = require('../../../../models/reports/scheduledReport');
var reportModel = require('../../../../models/reports/report');
var developerOptions = require('./developerOptions');

var ScheduledReportModal = Object.create(Model);
Object.assign(ScheduledReportModal, scheduledReportModel);

function getDefaultTimezone() {
  try {
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (timezone && moment.tz.zone(timezone)) {
      return timezone;
    }
  } catch (e) {}
  return 'America/New_York';
}

var DEFAULT_TIMEZONE = getDefaultTimezone();
var FRIENDLY_TIMEZONE_LABELS = {
  'America/New_York': 'Eastern Time',
  'America/Detroit': 'Eastern Time',
  'America/Kentucky/Louisville': 'Eastern Time (Kentucky)',
  'America/Kentucky/Monticello': 'Eastern Time (Kentucky)',
  'America/Indiana/Indianapolis': 'Eastern Time (Indiana)',
  'America/Indiana/Marengo': 'Eastern Time (Indiana)',
  'America/Indiana/Petersburg': 'Eastern Time (Indiana)',
  'America/Indiana/Vevay': 'Eastern Time (Indiana)',
  'America/Indiana/Vincennes': 'Eastern Time (Indiana)',
  'America/Indiana/Winamac': 'Eastern Time (Indiana)',
  'America/Chicago': 'Central Time',
  'America/Menominee': 'Central Time',
  'America/North_Dakota/Center': 'Central Time (North Dakota)',
  'America/North_Dakota/New_Salem': 'Central Time (North Dakota)',
  'America/North_Dakota/Beulah': 'Central Time (North Dakota)',
  'America/Indiana/Knox': 'Central Time (Indiana)',
  'America/Indiana/Tell_City': 'Central Time (Indiana)',
  'America/Denver': 'Mountain Time',
  'America/Boise': 'Mountain Time',
  'America/Phoenix': 'Mountain Time (Arizona)',
  'America/Los_Angeles': 'Pacific Time',
  'America/Anchorage': 'Alaska Time',
  'America/Juneau': 'Alaska Time',
  'America/Sitka': 'Alaska Time',
  'America/Metlakatla': 'Alaska Time',
  'America/Yakutat': 'Alaska Time',
  'America/Nome': 'Alaska Time',
  'America/Adak': 'Aleutian Time',
  'Pacific/Honolulu': 'Hawaii Time'
};
var TIMEZONE_OPTIONS = (moment.tz && typeof moment.tz.zonesForCountry === 'function')
  ? moment.tz.zonesForCountry('US')
  : [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Phoenix',
    'America/Los_Angeles',
    'America/Anchorage',
    'America/Adak',
    'Pacific/Honolulu'
  ];

var REPORT_FAKE_TIMESERIES_KEY = 'nimrod:report-fake-timeseries';
var CRON_PRESETS = [
  { label: 'Hourly', value: '0 * * * *' },
  { label: 'Daily 8 AM', value: '0 8 * * *' },
  { label: 'Weekdays 8 AM', value: '0 8 * * 1-5' },
  { label: 'Weekly Mon 8 AM', value: '0 8 * * 1' },
  { label: 'Monthly 1st 8 AM', value: '0 8 1 * *' }
];

function buildTimezoneLabel(timezone) {
  if (!timezone) return '';
  var friendly = FRIENDLY_TIMEZONE_LABELS[timezone];
  if (friendly) {
    return friendly + ' (' + timezone + ')';
  }
  var parts = String(timezone).split('/');
  if (parts[0] === 'America') {
    parts.shift();
  }
  var pretty = parts.join(' / ').replace(/_/g, ' ');
  return pretty + ' (' + timezone + ')';
}

function getWindowObject() {
  if (typeof window === 'undefined') return null;
  return window;
}

function shouldShowDeveloperReportOptions() {
  return developerOptions.shouldShowDeveloperReportOptions();
}

function getStoredFakeTimeseriesPreference() {
  if (!shouldShowDeveloperReportOptions()) return false;
  var win = getWindowObject();
  if (!win) return false;
  try {
    return win.localStorage && win.localStorage.getItem(REPORT_FAKE_TIMESERIES_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

function setStoredFakeTimeseriesPreference(enabled) {
  var win = getWindowObject();
  if (!win) return;
  try {
    if (win.localStorage) {
      win.localStorage.setItem(REPORT_FAKE_TIMESERIES_KEY, enabled ? 'true' : 'false');
    }
  } catch (e) {}
}

ScheduledReportModal.groups = null;
ScheduledReportModal.context = null;

function getAllowedDownloadFormats(reportType, explicitFormats) {
  var providedFormats = Array.isArray(explicitFormats) ? explicitFormats.filter(Boolean) : [];
  if (providedFormats.length) {
    return providedFormats;
  }
  if (reportModel && typeof reportModel.getAllowedDownloadFormats === 'function') {
    var manifestFormats = reportModel.getAllowedDownloadFormats(reportType || 'Custom Export');
    if (Array.isArray(manifestFormats) && manifestFormats.length) {
      return manifestFormats;
    }
  }
  return reportType === 'Custom Export' ? ['xlsx'] : ['pdf', 'xlsx'];
}

function getDefaultDownloadFormat(reportType, explicitFormats) {
  var formats = getAllowedDownloadFormats(reportType, explicitFormats);
  if (formats.indexOf('pdf') >= 0) return 'pdf';
  return formats[0] || 'xlsx';
}

function supportsRollupInterval(reportType, params) {
  if (params && Object.prototype.hasOwnProperty.call(params, 'intervalMinutes')) {
    return true;
  }
  var defaults = reportModel && typeof reportModel.getScheduleDefaults === 'function'
    ? (reportModel.getScheduleDefaults(reportType) || {})
    : {};
  var defaultParams = defaults && defaults.defaultParams ? defaults.defaultParams : {};
  return Object.prototype.hasOwnProperty.call(defaultParams, 'intervalMinutes');
}

function getFormatLabel(format) {
  if (format === 'xlsx') return 'Excel';
  if (format === 'json') return 'JSON';
  return 'PDF';
}

function normalizeGroupSelection(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return [value];
}

function buildParamsFromOptions(options) {
  var reportType = options && options.reportType ? options.reportType : '';
  var isCustomExport = reportType === 'Custom Export';
  var defaults = reportModel && typeof reportModel.getScheduleDefaults === 'function'
    ? (reportModel.getScheduleDefaults(reportType) || {})
    : {};
  var params = Object.assign({}, defaults && defaults.defaultParams ? defaults.defaultParams : {});

  if (options && options.params && typeof options.params === 'object') {
    params = Object.assign(params, options.params);
  }

  if (!isCustomExport && Array.isArray(options && options.dates) && options.dates.length === 2) {
    var start = moment(options.dates[0]);
    var stop = moment(options.dates[1]);
    var diff = Math.abs(stop.diff(start, 'days'));
    if (diff) {
      params.span = Math.max(1, Math.round(diff));
      params.resample = 'days';
      params.bucket = params.bucket || '10_years';
    }
  }

  if (!isCustomExport && options && options.span != null) {
    params.span = Number(options.span) || params.span;
  }
  if (!isCustomExport && options && options.resample) {
    params.resample = options.resample;
  }
  if (options && options.fakeTimeseries && shouldShowDeveloperReportOptions()) {
    params.fakeTimeseries = true;
  }

  return params;
}

function loadGroups() {
  return loaders.requestWithLoader({
    url: '/api/v1/group/',
    method: 'GET',
    loader: 'background'
  }).then(function (result) {
    ScheduledReportModal.groups = Array.isArray(result) ? result.map(function (group) {
      return { key: group.name, value: group['@rid'] };
    }) : [];
  }).catch(function () {
    ScheduledReportModal.groups = [];
  });
}

function loadOneDriveStatus() {
  return loaders.requestWithLoader({
    url: '/api/v1/report/delivery/onedrive/status',
    method: 'GET',
    loader: 'background',
    background: true
  }).then(function (result) {
    if (ScheduledReportModal.context) {
      ScheduledReportModal.context.oneDriveStatus = result || { configured: false };
      if (!ScheduledReportModal.context.isEdit && result && result.defaultFolder && !ScheduledReportModal.form.oneDriveFolder()) {
        ScheduledReportModal.form.oneDriveFolder(result.defaultFolder);
      }
    }
  }).catch(function () {
    if (ScheduledReportModal.context) ScheduledReportModal.context.oneDriveStatus = { configured: false, unavailable: true };
  });
}

ScheduledReportModal.editDialogue = function (options, meta) {
  var record = null;
  var localOptions = options || {};
  var localMeta = meta || {};
  var isCustomExport = localOptions.reportType === 'Custom Export';

  if (localOptions && localOptions['@rid']) {
    record = localOptions;
  } else if (localOptions && localOptions.record && localOptions.record['@rid']) {
    record = localOptions.record;
  }

  ScheduledReportModal.context = {
    options: localOptions,
    meta: localMeta,
    isEdit: Boolean(record && record['@rid']),
    lockTriggerType: Boolean(localMeta.lockTriggerType || localOptions.lockTriggerType),
    supportsEventNotifications: Boolean(localOptions.supportsEventNotifications),
    allowedFormats: getAllowedDownloadFormats(localOptions.reportType, localOptions.downloadFormats),
    requestInitialRun: Boolean(!record && isCustomExport),
    oneDriveStatus: null,
    oneDriveValidation: null
  };

  ScheduledReportModal.initForm(record || {});

  ScheduledReportModal.form.groups(normalizeGroupSelection(ScheduledReportModal.form.groups()));

  if (!ScheduledReportModal.context.isEdit) {
    if (localOptions.modalTitle && !ScheduledReportModal.form.name()) {
      var defaultName = String(localOptions.modalTitle).replace(/^Download\s+/i, '').trim();
      ScheduledReportModal.form.name(defaultName);
    }
    if (!ScheduledReportModal.form.name() && localOptions.reportName) {
      ScheduledReportModal.form.name(localOptions.reportName);
    }
    if (localOptions.reportName) {
      ScheduledReportModal.form.reportName(localOptions.reportName);
    }
    if (localOptions.reportType) {
      ScheduledReportModal.form.reportType(localOptions.reportType);
    }
    if (localOptions.reportRid) {
      ScheduledReportModal.form.reportRid(localOptions.reportRid);
    }
    if (localOptions.sourceKind) {
      ScheduledReportModal.form.sourceKind(localOptions.sourceKind);
    }
    if (localOptions.targetKind) {
      ScheduledReportModal.form.targetKind(localOptions.targetKind);
    }
    if (localOptions.targetRid) {
      ScheduledReportModal.form.targetRid(localOptions.targetRid);
    }
    if (localOptions.targetClassName) {
      ScheduledReportModal.form.targetClassName(localOptions.targetClassName);
    }
    if (localOptions.locationRid) {
      ScheduledReportModal.form.locationRid(localOptions.locationRid);
    }
    if (localOptions.recordId) {
      ScheduledReportModal.form.recordId(localOptions.recordId);
    }
    if (!ScheduledReportModal.form.params() || Object.keys(ScheduledReportModal.form.params()).length === 0) {
      ScheduledReportModal.form.params(buildParamsFromOptions(localOptions));
    }
    if (isCustomExport) {
      var customExportDefaults = buildParamsFromOptions({ reportType: localOptions.reportType });
      ScheduledReportModal.form.params(Object.assign({}, ScheduledReportModal.form.params() || {}, {
        span: Number(customExportDefaults.span) || 7,
        resample: customExportDefaults.resample || 'days',
        bucket: customExportDefaults.bucket || '3_years',
        intervalMinutes: Number(customExportDefaults.intervalMinutes) || 15,
        statistic: 'mean',
        useNow: true
      }));
      ScheduledReportModal.form.initialLookbackDays(90);
      ScheduledReportModal.form.cron('0 8 * * 1');
    }
  }

  if (!ScheduledReportModal.form.triggerType()) {
    if (localOptions.triggerType) {
      ScheduledReportModal.form.triggerType(localOptions.triggerType);
    } else if (localOptions.downloadRequiresEvent === true) {
      ScheduledReportModal.form.triggerType('event');
    } else if (localOptions.downloadRequiresEvent === false) {
      ScheduledReportModal.form.triggerType('cron');
    } else if (localOptions.reportRid) {
      ScheduledReportModal.form.triggerType('event');
    } else {
      ScheduledReportModal.form.triggerType('cron');
    }
  }
  if (isCustomExport) {
    ScheduledReportModal.form.triggerType('cron');
  }
  if (!ScheduledReportModal.form.sourceKind()) {
    ScheduledReportModal.form.sourceKind(localOptions.sourceKind || (localOptions.reportRid ? 'reportRecord' : 'direct'));
  }

  if (!ScheduledReportModal.form.timezone()) {
    ScheduledReportModal.form.timezone(DEFAULT_TIMEZONE);
  }

  if (!ScheduledReportModal.context.isEdit && shouldShowDeveloperReportOptions()) {
    var currentParams = ScheduledReportModal.form.params() || {};
    if (typeof currentParams.fakeTimeseries === 'undefined' && getStoredFakeTimeseriesPreference()) {
      ScheduledReportModal.form.params(Object.assign({}, currentParams, { fakeTimeseries: true }));
    }
  }

  var allowedFormats = ScheduledReportModal.context.allowedFormats || ['xlsx'];

  if (!ScheduledReportModal.form.format() && localOptions.format && allowedFormats.indexOf(localOptions.format) >= 0) {
    ScheduledReportModal.form.format(localOptions.format);
  }

  if (isCustomExport) {
    ScheduledReportModal.form.format('xlsx');
  }

  if (!ScheduledReportModal.form.format() || allowedFormats.indexOf(ScheduledReportModal.form.format()) < 0) {
    ScheduledReportModal.form.format(getDefaultDownloadFormat(localOptions.reportType, allowedFormats));
  }

  if (typeof ScheduledReportModal.form.enabled() === 'undefined' || ScheduledReportModal.form.enabled() === null) {
    ScheduledReportModal.form.enabled(true);
  }
  if (typeof ScheduledReportModal.form.scheduleEnabled() === 'undefined' || ScheduledReportModal.form.scheduleEnabled() === null) {
    ScheduledReportModal.form.scheduleEnabled(
      localOptions.triggerType !== 'event' && (!record || record.triggerType !== 'event')
    );
  }
  if (typeof ScheduledReportModal.form.notifyOnNewEvents() === 'undefined' || ScheduledReportModal.form.notifyOnNewEvents() === null) {
    ScheduledReportModal.form.notifyOnNewEvents(false);
  }

  Promise.all([loadGroups(), loadOneDriveStatus()]).then(function () { m.redraw(); });

  modal.vm.title(ScheduledReportModal.context.isEdit ? 'Edit Scheduled Report' : 'Schedule Report');
  modal.vm.body = ScheduledReportModal.view;
  modal.vm.buttons([
    {
      label: 'Cancel',
      class: 'dib mr2',
      func: function () { modal.vm.close(); }
    },
    {
      label: ScheduledReportModal.context.isEdit ? 'Save' : 'Schedule',
      class: 'dib green',
      func: ScheduledReportModal.submit
    }
  ]);

  modal.vm.open();
};

ScheduledReportModal.submit = function () {
  var context = ScheduledReportModal.context || {};
  var options = context.options || {};
  var errors = [];
  var triggerType = ScheduledReportModal.form.triggerType() || 'cron';
  var isCustomExport = options.reportType === 'Custom Export';
  var supportsEventNotifications = Boolean(context.supportsEventNotifications);
  var scheduleEnabled = Boolean(ScheduledReportModal.form.scheduleEnabled());
  var notifyOnNewEvents = Boolean(ScheduledReportModal.form.notifyOnNewEvents());
  if (isCustomExport) {
    ScheduledReportModal.form.triggerType('cron');
    triggerType = 'cron';
    ScheduledReportModal.form.scheduleEnabled(true);
    scheduleEnabled = true;
  }
  if (!supportsEventNotifications) {
    ScheduledReportModal.form.notifyOnNewEvents(false);
    notifyOnNewEvents = false;
    if (options.downloadRequiresEvent !== true) {
      ScheduledReportModal.form.triggerType('cron');
      triggerType = 'cron';
      if (!scheduleEnabled) {
        ScheduledReportModal.form.scheduleEnabled(true);
        scheduleEnabled = true;
      }
    }
  }
  if (!isCustomExport && supportsEventNotifications) {
    triggerType = triggerType === 'event' || notifyOnNewEvents ? 'event' : 'cron';
    ScheduledReportModal.form.triggerType(triggerType);
  }

  if (!ScheduledReportModal.form.reportName() && options.reportName) {
    ScheduledReportModal.form.reportName(options.reportName);
  }
  if (!ScheduledReportModal.form.reportType() && options.reportType) {
    ScheduledReportModal.form.reportType(options.reportType);
  }
  if (!ScheduledReportModal.form.reportRid() && options.reportRid) {
    ScheduledReportModal.form.reportRid(options.reportRid);
  }
  if (!ScheduledReportModal.form.sourceKind()) {
    ScheduledReportModal.form.sourceKind(options.sourceKind || (options.reportRid ? 'reportRecord' : 'direct'));
  }
  if (!ScheduledReportModal.form.targetKind() && options.targetKind) {
    ScheduledReportModal.form.targetKind(options.targetKind);
  }
  if (!ScheduledReportModal.form.targetRid() && options.targetRid) {
    ScheduledReportModal.form.targetRid(options.targetRid);
  }
  if (!ScheduledReportModal.form.targetClassName() && options.targetClassName) {
    ScheduledReportModal.form.targetClassName(options.targetClassName);
  }
  if (!ScheduledReportModal.form.locationRid() && options.locationRid) {
    ScheduledReportModal.form.locationRid(options.locationRid);
  }
  if (!ScheduledReportModal.form.recordId() && options.recordId) {
    ScheduledReportModal.form.recordId(options.recordId);
  }
  if (!ScheduledReportModal.form.params() || Object.keys(ScheduledReportModal.form.params()).length === 0) {
    ScheduledReportModal.form.params(buildParamsFromOptions(options));
  }

  ScheduledReportModal.form.groups(normalizeGroupSelection(ScheduledReportModal.form.groups()));
  var selectedGroups = ScheduledReportModal.form.groups();
  var deliveryMethod = String(ScheduledReportModal.form.deliveryMethod() || 'link').toLowerCase();

  if (scheduleEnabled && !ScheduledReportModal.form.cron()) {
    errors.push('Cron is required for scheduled reports.');
  }
  if (triggerType === 'event' && !ScheduledReportModal.form.reportRid()) {
    errors.push('Event-based reports require a report selection.');
  }
  if (!ScheduledReportModal.form.reportType()) {
    errors.push('Report type is required.');
  }
  if (ScheduledReportModal.form.sourceKind() === 'direct' && !ScheduledReportModal.form.targetRid()) {
    errors.push('Direct schedules require a target.');
  }
  if (!scheduleEnabled && triggerType !== 'event' && !notifyOnNewEvents) {
    errors.push('Enable scheduled or event delivery.');
  }
  if ((scheduleEnabled || triggerType === 'event' || notifyOnNewEvents) && deliveryMethod !== 'onedrive' && selectedGroups.length === 0) {
    errors.push('Choose at least one receiver group.');
  }
  if (deliveryMethod === 'onedrive' && !String(ScheduledReportModal.form.oneDriveFolder() || '').trim()) {
    errors.push('Choose a SharePoint folder.');
  }
  if (deliveryMethod === 'onedrive' && context.oneDriveStatus && !context.oneDriveStatus.configured) {
    errors.push('SharePoint delivery is not configured on this server.');
  }
  if (deliveryMethod === 'onedrive' && context.oneDriveStatus && context.oneDriveStatus.enabled === false && !context.isEdit) {
    errors.push('SharePoint delivery is disabled. Enable it before creating this schedule.');
  }
  if (ScheduledReportModal.form.endAt() && Number(ScheduledReportModal.form.endAt()) <= Date.now()) {
    errors.push('The end date must be in the future.');
  }

  if (errors.length) {
    ScheduledReportModal.errors = errors;
    m.redraw();
    return Promise.reject(errors);
  }

  if (!scheduleEnabled) {
    ScheduledReportModal.form.cron(null);
    ScheduledReportModal.form.timezone(null);
  } else {
    var params = ScheduledReportModal.form.params() || {};
    if (params && params.span) {
      ScheduledReportModal.form.params(Object.assign({}, params, { useNow: true }));
    }
  }

  if (triggerType === 'event' && !context.isEdit && !ScheduledReportModal.form.lastRunAt()) {
    ScheduledReportModal.form.lastRunAt(Date.now());
  }
  if (triggerType === 'event' && ScheduledReportModal.form.notifyOnNewEvents() && !ScheduledReportModal.form.lastEventScanAt()) {
    ScheduledReportModal.form.lastEventScanAt(Date.now());
  }
  if (isCustomExport && context.requestInitialRun) {
    ScheduledReportModal.form.initialRunStatus('pending');
    ScheduledReportModal.form.initialRunRequestedAt(Date.now());
    ScheduledReportModal.form.initialRunStartedAt(null);
    ScheduledReportModal.form.initialRunCompletedAt(null);
    ScheduledReportModal.form.initialRunAttempts(0);
    ScheduledReportModal.form.initialRunNextAttemptAt(Date.now());
  }

  return ScheduledReportModal.save()
    .then(function () {
      modal.vm.close();
      if (context.meta && typeof context.meta.submitCallback === 'function') {
        context.meta.submitCallback();
      }
    });
};

function buildWindowLabel(params) {
  if (!params || !params.span || !params.resample) return null;
  var unit = String(params.resample);
  if (Number(params.span) === 1 && /s$/.test(unit)) {
    unit = unit.slice(0, -1);
  }
  return 'Report window: last ' + params.span + ' ' + unit;
}

function buildCronDescription(cron, timezone) {
  if (!cron) return null;
  try {
    var description = cronstrue.toString(String(cron));
    if (timezone) {
      description += ' (' + timezone + ')';
    }
    return description;
  } catch (e) {
    return 'Invalid cron expression';
  }
}

function updateParamField(key, value) {
  var params = ScheduledReportModal.form.params() || {};
  var next = Object.assign({}, params);
  next[key] = value;
  ScheduledReportModal.form.params(next);
}

function getParamField(key, fallback) {
  var params = ScheduledReportModal.form.params() || {};
  if (params && typeof params[key] !== 'undefined' && params[key] !== null) {
    return params[key];
  }
  return fallback;
}

function validateOneDriveFolder() {
  var context = ScheduledReportModal.context || {};
  context.oneDriveValidation = { loading: true };
  m.redraw();
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/report/delivery/onedrive/validate',
    method: 'POST',
    background: true,
    body: { folderPath: ScheduledReportModal.form.oneDriveFolder() }
  }).then(function (result) {
    context.oneDriveValidation = { valid: true, message: 'Folder is accessible.', folder: result && result.folder };
  }).catch(function (error) {
    context.oneDriveValidation = { valid: false, message: error && error.error ? error.error : 'Folder could not be accessed.' };
  }).finally(function () {
    m.redraw();
  });
}

function buildDeliveryControl() {
  var deliveryMethod = ScheduledReportModal.form.deliveryMethod() || 'link';
  var context = ScheduledReportModal.context || {};
  var oneDriveStatus = context.oneDriveStatus;
  var validation = context.oneDriveValidation;
  return [
    m('label.db', 'Delivery:'),
    m('select.input-reset.ba.b--black-20.pa2.mb2.w-100', {
      onchange: function (ev) { ScheduledReportModal.form.deliveryMethod(ev.target.value); },
      value: deliveryMethod
    }, [
      m('option', { value: 'link' }, 'Download Link'),
      m('option', { value: 'attachment' }, 'File Attachment'),
      m('option', {
        value: 'onedrive',
        disabled: Boolean(oneDriveStatus && oneDriveStatus.enabled === false && deliveryMethod !== 'onedrive')
      }, 'SharePoint Folder')
    ]),
    deliveryMethod === 'onedrive' ? m('div.mb2.pa3.ba.b--black-10.br2', [
      m('label.db', 'SharePoint folder:'),
      m('input.input-reset.ba.b--black-20.pa2.mb2.w-100', {
        type: 'text',
        value: ScheduledReportModal.form.oneDriveFolder() || '',
        placeholder: 'Shared Documents/Trend Reports',
        oninput: function (event) {
          ScheduledReportModal.form.oneDriveFolder(event.target.value);
          context.oneDriveValidation = null;
        }
      }),
      m('button.input-reset.pointer.ba.br2.ph2.pv1.blue.b--blue.bg-transparent', {
        type: 'button',
        disabled: !oneDriveStatus || !oneDriveStatus.configured || !ScheduledReportModal.form.oneDriveFolder(),
        onclick: validateOneDriveFolder
      }, validation && validation.loading ? 'Checking...' : 'Check folder'),
      oneDriveStatus && !oneDriveStatus.configured
        ? m('div.red.f6.mt2', 'SharePoint delivery is not configured on this server.')
        : null,
      oneDriveStatus && oneDriveStatus.enabled === false
        ? m('div.dark-orange.f6.mt2', 'SharePoint delivery is disabled. Existing schedules remain paused until it is enabled.')
        : null,
      oneDriveStatus && oneDriveStatus.authMethod === 'certificate' && oneDriveStatus.certificate &&
        ['notice', 'warning', 'critical', 'expired'].indexOf(oneDriveStatus.certificate.expirationState) >= 0
        ? m('div.dark-orange.f6.mt2', oneDriveStatus.certificate.expirationState === 'expired'
          ? 'The SharePoint certificate has expired.'
          : 'The SharePoint certificate expires in ' + oneDriveStatus.certificate.daysUntilExpiration + ' days.')
        : null,
      validation && !validation.loading
        ? m('div.f6.mt2', { class: validation.valid ? 'green' : 'red' }, validation.message)
        : null
    ]) : null
  ];
}

function buildCronHelper() {
  return m('div.mb2', [
    m('div.f6.gray.mb1', 'Quick schedules'),
    m('div.flex.flex-wrap', CRON_PRESETS.map(function (preset) {
      var selected = ScheduledReportModal.form.cron() === preset.value;
      return m('button.input-reset.pointer.ba.br2.ph2.pv1.mr2.mb2', {
        type: 'button',
        class: selected ? 'bg-blue white b--blue' : 'bg-transparent blue b--blue',
        onclick: function () {
          ScheduledReportModal.form.cron(preset.value);
        }
      }, preset.label);
    }))
  ]);
}

ScheduledReportModal.view = function () {
  if (!ScheduledReportModal.form) return m('div');

  var context = ScheduledReportModal.context || {};
  var isCustomExport = context.options && context.options.reportType === 'Custom Export';
  var groupsData = ScheduledReportModal.groups;
  var params = ScheduledReportModal.form.params();
  var windowLabel = buildWindowLabel(params);
  var triggerType = ScheduledReportModal.form.triggerType() || 'cron';
  var cronExpression = ScheduledReportModal.form.cron();
  var cronDescription = buildCronDescription(cronExpression, ScheduledReportModal.form.timezone());
  var cronInvalid = Boolean(cronExpression) && cronDescription === 'Invalid cron expression';
  var timezoneValue = ScheduledReportModal.form.timezone() || DEFAULT_TIMEZONE;
  var timezoneOptions = TIMEZONE_OPTIONS;
  if (timezoneValue && TIMEZONE_OPTIONS.indexOf(timezoneValue) === -1) {
    timezoneOptions = [timezoneValue].concat(TIMEZONE_OPTIONS);
  }
  var sortedTimezoneOptions = timezoneOptions.slice().sort(function (a, b) {
    return buildTimezoneLabel(a).localeCompare(buildTimezoneLabel(b), 'en', { sensitivity: 'base' });
  });
  var paramsSpan = getParamField('span', 24);
  var paramsResample = getParamField('resample', 'hours');
  var paramsSnapshot = ScheduledReportModal.form.params() || {};
  var hasRollupInterval = supportsRollupInterval(context.options && context.options.reportType, paramsSnapshot);
  var showRangeInputs = Boolean((paramsSnapshot && (paramsSnapshot.span || paramsSnapshot.resample)) || (context.options && context.options.reportType === 'Custom Export'));
  var notifyOnNewEvents = Boolean(ScheduledReportModal.form.notifyOnNewEvents());
  var scheduleEnabled = Boolean(ScheduledReportModal.form.scheduleEnabled());
  var supportsEventNotifications = Boolean(context.supportsEventNotifications);
  if (!supportsEventNotifications && !isCustomExport && context.options && context.options.downloadRequiresEvent !== true && triggerType === 'event') {
    ScheduledReportModal.form.triggerType('cron');
    triggerType = 'cron';
    if (!scheduleEnabled) {
      ScheduledReportModal.form.scheduleEnabled(true);
      scheduleEnabled = true;
    }
  }
  var showsEmailDelivery = Boolean(scheduleEnabled || triggerType === 'event' || notifyOnNewEvents);
  var allowedFormats = context.allowedFormats || getAllowedDownloadFormats(context.options && context.options.reportType, context.options && context.options.downloadFormats);
  var fakeTimeseriesEnabled = Boolean(getParamField('fakeTimeseries', false));
  var deliveryMethod = String(ScheduledReportModal.form.deliveryMethod() || 'link').toLowerCase();
  var endDateValue = ScheduledReportModal.form.endAt()
    ? moment(Number(ScheduledReportModal.form.endAt())).tz(timezoneValue).format('YYYY-MM-DD')
    : '';

  return m('form', { role: 'form' }, [
    ScheduledReportModal.errorView(),
    m('div.mb2', [
      m('div.flex.items-center.justify-between', [
        m('span', 'Enabled'),
        m(ToggleSwitch, {
          id: 'scheduled-report-enabled-toggle',
          checked: Boolean(ScheduledReportModal.form.enabled()),
          ariaLabel: 'Scheduled report enabled',
          onchange: function () {
            var current = Boolean(ScheduledReportModal.form.enabled());
            ScheduledReportModal.form.enabled(!current);
          }
        })
      ])
    ]),
    m('label', 'Name:'),
    m('input.input-reset.ba.b--black-20.pa2.mb2.w-100', {
      type: 'text',
      autocomplete: 'off',
      value: ScheduledReportModal.form.name() || '',
      oninput: function (ev) { ScheduledReportModal.form.name(ev.target.value); }
    }),
    supportsEventNotifications && !isCustomExport ? m('div.mb2', [
      m('div.flex.items-center.justify-between', [
        m('div.pr3', [
          m('div', 'Send on event'),
          m('div.gray.f6', 'Generate and deliver this report when report events are detected.')
        ]),
        m(ToggleSwitch, {
          id: 'scheduled-report-send-on-event-toggle',
          checked: triggerType === 'event',
          ariaLabel: 'Send on event',
          onchange: function () {
            var nextValue = ScheduledReportModal.form.triggerType() !== 'event';
            ScheduledReportModal.form.triggerType(nextValue ? 'event' : 'cron');
            if (!nextValue) {
              ScheduledReportModal.form.notifyOnNewEvents(false);
            }
          }
        })
      ]),
    ]) : null,
    supportsEventNotifications && !isCustomExport ? m('div.mb2', [
      m('div.flex.items-center.justify-between', [
        m('div.pr3', [
          m('div', 'Send event start notifications'),
          m('div.gray.f6', 'Send an email when a report event starts.')
        ]),
        m(ToggleSwitch, {
          id: 'scheduled-report-notify-on-new-events-toggle',
          checked: notifyOnNewEvents,
          ariaLabel: 'Send event start notifications',
          onchange: function () {
            var nextValue = !Boolean(ScheduledReportModal.form.notifyOnNewEvents());
            ScheduledReportModal.form.notifyOnNewEvents(nextValue);
            if (nextValue) {
              ScheduledReportModal.form.triggerType('event');
            }
          }
        })
      ]),
    ]) : null,
    supportsEventNotifications && !isCustomExport ? m('div.mb2', [
      m('div.flex.items-center.justify-between', [
        m('div.pr3', [
          m('div', 'Send on schedule'),
          m('div.gray.f6', 'Use the cron schedule below in addition to any event-based delivery.')
        ]),
        m(ToggleSwitch, {
          id: 'scheduled-report-schedule-enabled-toggle',
          checked: scheduleEnabled,
          ariaLabel: 'Send on schedule',
          onchange: function () {
            var nextValue = !Boolean(ScheduledReportModal.form.scheduleEnabled());
            ScheduledReportModal.form.scheduleEnabled(nextValue);
            if (!nextValue && ScheduledReportModal.form.triggerType() === 'cron' && supportsEventNotifications) {
              ScheduledReportModal.form.triggerType('event');
            }
          }
        })
      ])
    ]) : null,
    scheduleEnabled ? m('div.mb2.pa3.ba.b--black-10.br2', [
      showRangeInputs ? m('div.mb2', [
        m('div.flex.flex-wrap', [
          hasRollupInterval ? m('div.mr2', [
            m('label.db', { for: 'scheduled-report-duration-input' }, 'Duration'),
            m('input.input-reset.ba.b--black-20.pa2.w4', {
              id: 'scheduled-report-duration-input',
              type: 'number',
              min: 1,
              value: paramsSpan,
              oninput: function (ev) { updateParamField('span', Number(ev.target.value) || 1); }
            })
          ]) : null,
          hasRollupInterval ? m('div', [
            m('label.db', { for: 'scheduled-report-duration-unit-input' }, 'Duration unit'),
            m('select.input-reset.ba.b--black-20.pa2', {
              id: 'scheduled-report-duration-unit-input',
              onchange: function (ev) { updateParamField('resample', ev.target.value); },
              value: paramsResample
            }, [
              m('option', { value: 'hours' }, 'Hours'),
              m('option', { value: 'days' }, 'Days'),
              m('option', { value: 'weeks' }, 'Weeks')
            ])
          ]) : null,
          !hasRollupInterval ? [
            m('label', isCustomExport ? 'Recurring report range:' : 'Report window:'),
          m('input.input-reset.ba.b--black-20.pa2.mr2.w4', {
            type: 'number',
            min: 1,
            value: paramsSpan,
            oninput: function (ev) { updateParamField('span', Number(ev.target.value) || 1); }
          }),
          m('select.input-reset.ba.b--black-20.pa2', {
            onchange: function (ev) { updateParamField('resample', ev.target.value); },
            value: paramsResample
          }, [
            m('option', { value: 'hours' }, 'Hours'),
            m('option', { value: 'days' }, 'Days')
          ])
          ] : null
        ])
      ]) : null,
      hasRollupInterval ? m('div.mb2', [
        m('label.db', { for: 'scheduled-report-rollup-input' }, 'Rollup'),
        m('select.input-reset.ba.b--black-20.pa2.mb2.w-100', {
          id: 'scheduled-report-rollup-input',
          value: String(getParamField('intervalMinutes', 15)),
          onchange: function (event) { updateParamField('intervalMinutes', Number(event.target.value)); }
        }, [
          m('option', { value: '5' }, '5 minutes'),
          m('option', { value: '15' }, '15 minutes'),
          m('option', { value: '30' }, '30 minutes'),
          m('option', { value: '60' }, '1 hour'),
          m('option', { value: '360' }, '6 hours'),
          m('option', { value: '1440' }, '1 day')
        ]),
        m('div.f6.gray', 'Mean of all values in each rollup interval. Empty intervals remain empty.')
      ]) : null,
      m('label', 'Cron:'),
      m('input.input-reset.ba.b--black-20.pa2.mb1.w-100', {
        type: 'text',
        autocomplete: 'off',
        value: ScheduledReportModal.form.cron() || '',
        oninput: function (ev) { ScheduledReportModal.form.cron(ev.target.value); }
      }),
      buildCronHelper(),
      cronDescription ? m('div.f6.mb2', { class: cronInvalid ? 'red' : 'gray' }, 'Schedule: ' + cronDescription) : null,
      m('label', 'Timezone:'),
      m('select.input-reset.ba.b--black-20.pa2.mb0.w-100', {
        onchange: function (ev) { ScheduledReportModal.form.timezone(ev.target.value); },
        value: timezoneValue
      }, sortedTimezoneOptions.map(function (timezone) {
        return m('option', { value: timezone }, buildTimezoneLabel(timezone));
      })),
      m('label.db.mt2', 'End after:'),
      m('input.input-reset.ba.b--black-20.pa2.mb0.w-100', {
        type: 'date',
        value: endDateValue,
        oninput: function (event) {
          ScheduledReportModal.form.endAt(event.target.value
            ? moment.tz(event.target.value, timezoneValue).endOf('day').valueOf()
            : null);
        }
      }),
      m('div.f6.gray.mt1', 'No recurring report will start after this date.')
    ]) : null,
    isCustomExport ? m('div.mb2.pa3.ba.b--black-10.br2', [
      m('div.flex.items-center.justify-between', [
        m('div.pr3', [
          m('div', 'Create initial report'),
          m('div.gray.f6', context.isEdit && ScheduledReportModal.form.initialRunStatus()
            ? 'Current status: ' + ScheduledReportModal.form.initialRunStatus()
            : 'Generate a separate historical file set after saving.')
        ]),
        m(ToggleSwitch, {
          id: 'scheduled-report-initial-run-toggle',
          checked: Boolean(context.requestInitialRun),
          ariaLabel: 'Create initial historical report',
          onchange: function () { context.requestInitialRun = !context.requestInitialRun; }
        })
      ]),
      context.requestInitialRun ? m('div.mt2', [
        m('label.db', 'Initial lookback:'),
        m('div.flex.items-center', [
          m('input.input-reset.ba.b--black-20.pa2.mr2.w4', {
            type: 'number',
            min: 1,
            max: 3650,
            value: ScheduledReportModal.form.initialLookbackDays() || 90,
            oninput: function (event) { ScheduledReportModal.form.initialLookbackDays(Number(event.target.value) || 90); }
          }),
          m('span', 'days')
        ])
      ]) : null
    ]) : null,
    m('label', 'Format:'),
    m('select.input-reset.ba.b--black-20.pa2.mb2.w-100', {
      onchange: function (ev) { ScheduledReportModal.form.format(ev.target.value); },
      value: ScheduledReportModal.form.format()
    }, allowedFormats.map(function (format) {
      return m('option', { value: format }, getFormatLabel(format));
    })),
    showsEmailDelivery ? buildDeliveryControl() : null,
    shouldShowDeveloperReportOptions() ? m('div.mb2.pa3.ba.b--black-10.br2', [
      m('div.flex.items-center.justify-between', [
        m('span', 'Use fake timeseries data'),
        m(ToggleSwitch, {
          id: 'scheduled-report-fake-timeseries-toggle',
          checked: fakeTimeseriesEnabled,
          ariaLabel: 'Use fake timeseries data for this scheduled report',
          onchange: function (ev) {
            var enabled = Boolean(ev.target.checked);
            updateParamField('fakeTimeseries', enabled);
            setStoredFakeTimeseriesPreference(enabled);
          }
        })
      ]),
      m('div.gray.f6.mt2', 'Developer option for generating chart-ready synthetic report data.')
    ]) : null,
    m('label', deliveryMethod === 'onedrive' ? 'Email notification groups (optional):' : 'Receiver Groups:'),
    m('div.mb2', [
      groupsData === null
        ? m('div.gray', 'Loading groups...')
        : (groupsData.length === 0
          ? m('div.gray', 'No groups available.')
          : m(choices, {
            data: groupsData,
            value: ScheduledReportModal.form.groups,
            placeholderValue: 'Select groups'
          }))
    ]),
    windowLabel ? m('div.gray.f6', windowLabel) : null
  ]);
};

ScheduledReportModal._private = {
  shouldShowDeveloperReportOptions: shouldShowDeveloperReportOptions,
  getStoredFakeTimeseriesPreference: getStoredFakeTimeseriesPreference,
  buildParamsFromOptions: buildParamsFromOptions,
  buildWindowLabel: buildWindowLabel,
  supportsRollupInterval: supportsRollupInterval
};

module.exports = ScheduledReportModal;
